import React from 'react';
import { FiX, FiCalendar } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import MarketingCalendar from './MarketingCalendar';

const MarketingCalendarModal = ({ isOpen, onClose, highlightEventId }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[2000] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-fade-in" onClick={onClose}>
      <div className="max-h-[90vh] flex flex-col bg-white dark:bg-charcoal-900 w-full max-w-7xl h-[90vh] rounded-2xl shadow-2xl flex flex-col overflow-hidden border border-charcoal-200 dark:border-charcoal-800" onClick={(e) => e.stopPropagation()}>

        {/* Header */}
        <div className="shrink-0 flex items-center justify-end px-6 py-2 border-b border-charcoal-100 dark:border-charcoal-800 bg-white dark:bg-charcoal-900">
            <button
                onClick={onClose}
                className="p-2 hover:bg-charcoal-100 dark:hover:bg-charcoal-800 rounded-lg transition-colors text-charcoal-500"
                aria-label="Close marketing calendar"
            >
                <SafeIcon icon={FiX} className="text-xl" />
            </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6 bg-charcoal-50 dark:bg-charcoal-950 min-h-0">
             <MarketingCalendar showHolidays={true} highlightEventId={highlightEventId} />
        </div>

      </div>
    </div>
  );
};

export default MarketingCalendarModal;
